import { render, staticRenderFns } from "./JVXETableDemo.vue?vue&type=template&id=78af96ca&scoped=true"
import script from "./JVXETableDemo.vue?vue&type=script&lang=js"
export * from "./JVXETableDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af96ca",
  null
  
)

export default component.exports